import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @Input() headerItems: Array<any>;
  @Input() logoPath: string;
  @Input() title: string;
  @Input() logoPlace: "center" | "left" = "left";
  @Input() baseColor: string;
  @Input() scrolledColor: string;
  @Input() alertMessage: string;
  @Input() needAnimatonOnScroll: boolean;

  isNavbarCollapsed = false;

  constructor() {}

  ngOnInit() {
    if (this.logoPlace === "center" && this.headerItems.length % 2 !== 0) {
      this.logoPlace = "left";
    }
  }

  navBarClicked() {
    this.isNavbarCollapsed = false;
  }

  openLink(link: string): void {
    console.log(link);

    window.location.href = link;
  }
}
